let threshold = 765;
let firstrun = true;
let mobileInterval = undefined;
let activeMessage = 0;

document.addEventListener("DOMContentLoaded", function() {
    window.addEventListener('resize', function(event){
        if(this.window.innerWidth <= threshold){
            if(mobileInterval != undefined){
                clearInterval(mobileInterval);
            }
            hideDesktop();
            startAnnouncementChecker();
        }else{
            if(mobileInterval != undefined){
                clearInterval(mobileInterval);
                displayDesktop();
            }
        }

    });
    startAnnouncementChecker();

});

function startAnnouncementChecker(){
    let announcements = document.querySelectorAll('.announcement-bar')
    if(window.innerWidth <= threshold){
        if(firstrun == true){
            announcements[activeMessage].classList.add("active"); 
            firstrun = false; 
        }

        mobileInterval = setInterval(() => {
            let current = announcements[activeMessage];
            if(activeMessage == announcements.length - 1){
                activeMessage = 0;
            }else{
                activeMessage++;
            }
            let next = announcements[activeMessage];

            current.style.opacity = 0
            current.classList.remove("active")

            setTimeout(() => {
                current.style.display = "none";
                next.style.display = "block";
                next.classList.add("active")
                setTimeout(() => {
                    next.style.opacity = 1;
                }, 50);
            }, 750);

        },  (5000));

    }
}

function displayDesktop(){
    let announcements = document.querySelectorAll('.announcement__text')
    announcements.forEach(announcement => {
        announcement.classList.add('desktop_text')
    })
}

function hideDesktop(){
    let announcements = document.querySelectorAll('.announcement__text')
    announcements.forEach(announcement => {
        announcement.classList.remove('desktop_text')
    })
}